export default __webpack_public_path__ + "static/media/NoTruckPathImage.732b3372.svg";